import { logout } from '../lib/kratos';

export function TopBar({ title, email }: { title: string; email: string }) {
  return (
    <header className="flex h-14 items-center justify-between border-b border-line-soft bg-surface-white px-6">
      <h1 className="text-base font-semibold tracking-tightish text-ink-primary">{title}</h1>
      <div className="flex items-center gap-5 text-sm text-ink-secondary">
        <a
          href="https://developers.sigilkeys.com"
          target="_blank"
          rel="noreferrer"
          className="transition-colors hover:text-ink-primary"
        >
          Developers
        </a>
        <a href="mailto:support@sigilkeys.com" className="transition-colors hover:text-ink-primary">
          Support
        </a>
        <div className="h-5 w-px bg-line-soft" />
        <span className="hidden sm:inline">{email}</span>
        <button
          type="button"
          onClick={() => {
            void logout();
          }}
          className="transition-colors hover:text-ink-primary"
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
